export const setReactFormValues = (metaData, metaValue, value, keyValue) => {
  let valueArray = metaData?.[`${metaValue}`]?.map((object, i) => {
    return object[`${keyValue}`];
  });

  let matchedValues;
  if (Array.isArray(value)) {
    matchedValues = valueArray.filter((val) => value.includes(val));
  } else {
    matchedValues = valueArray.filter((val) => val === value);
  }

  return matchedValues;
};

export const areArraysEqual = (arr1, array2) => {
  let array1: any = [];
  if (typeof arr1 == "string") {
    array1.push(arr1);
  } else {
    array1 = [...arr1];
  }

  if (array1.length !== array2.length) {
    return false;
  }

  const sortedArray1 = array1.slice().sort();
  const sortedArray2 = array2.slice().sort();

  for (let i = 0; i < sortedArray1.length; i++) {
    if (sortedArray1[i] !== sortedArray2[i]) {
      return false;
    }
  }

  return true;
};
